<template>
    <div>
        <span size="mini" :style="{color:color}">{{condition}}</span>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
let _ = require('lodash');
export default {
    props: {
        data: {},
    },
    data() {
        return {
            condition: '',
            color: '#999999'
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                let nums = _.split(this.data.Condition, '/', 2);
                if (nums.length == 2) {
                    let resulte = _.round(_.divide(nums[0], nums[1]), 3);
                    if (resulte >= 0.7) {
                        this.color = '#158239'
                    } else if (resulte >= 0.5) {
                        this.color = '#f6921e'
                    } else {
                        this.color = '#c6221e'
                    }
                    this.condition = this.data.Condition + '(' + (resulte * 100).toFixed(1) + '%)';
                } else {
                    this.condition = '-';
                }
            }
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkConditionCell.vue